import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTask } from '../../services/TaskServices';
import KeycloakService from '../../services/KeycloakService';
import { TASK_DELETE_CLOSE } from '../../pages/Tasks/TaskConstants';
import { SHOW_NOTIFICATION } from '../../constants';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function BasicModal(props) {
  const currentUserId = KeycloakService.getUserDetail();
  const { setNotificationStatus, getTask, rows } = props;
  const userDataState = useSelector((state) => state.taskOperation);
  const dispatch = useDispatch();
  const handleClose = () =>
    dispatch({
      type: TASK_DELETE_CLOSE,
    });
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const deleteRowId = rows[userDataState.rowId].id;

  const handleSubmitDeleteTask = async () => {
    const deleteUserTask = await deleteTask(currentUserId, deleteRowId);
    if (deleteUserTask.isError === false) {
      dispatch({
        type: TASK_DELETE_CLOSE,
      });
      getTask();
    }
    dipatchNotification(deleteUserTask.type, deleteUserTask.message);
  };

  return (
    <div>
      <Modal
        open={userDataState.delete}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure you want to delete the task?
          </Typography>
          <div
            className="space-between-container "
            style={{ marginTop: '10px' }}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              size="small"
              onClick={handleSubmitDeleteTask}
            >
              Yes
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
